import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPICommonResponse,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPICheckUniquesnessModel,
  IAPIPromotionGrid,
  IAPIPromotionModel,
  IAPIUpdatePromotionModel,
} from "../interfaces/IAPIPromotionModels";
import AuthService from "./AuthService";

class PromotionService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getPromotionsGridData(
    accountId: string,
    pageNumber: number,
    pageSize: string,
    searchValue: string
  ): Observable<IAPIResponse<IAPIPromotionGrid[]>> {
    const params: string = buildParamString({
      accountId,
      pageNumber,
      pageSize,
      searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIPromotionGrid[]>>(
      url.getPromotionGridData,
      params
    );
  }

  getPromotionData(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<IAPIPromotionModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
    });
    return this.httpService.get<IAPIResponse<IAPIPromotionModel>>(
      url.getPromotion,
      params
    );
  }

  createPromotion(data: IAPIPromotionModel): Observable<IAPIResponse<string>> {
    return this.httpService.post<IAPIResponse<string>>(
      url.createPromotion,
      data
    );
  }

  updatePromotion(
    data: IAPIUpdatePromotionModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updatePromotion,
      data
    );
  }

  deletePromotion(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<boolean>> {
    const request = { accountId: accountId, id: id };
    return this.httpService.delete<IAPIResponse<boolean>>(
      url.deletePromotion,
      request
    );
  }

  checkCodeUniqueness(
    data: IAPICheckUniquesnessModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.post<IAPIResponse<boolean>>(
      url.checkCodeUniqueness,
      data
    );
  }

  checkPromoCodeByCode(
    code: string,
    accountId: string
  ): Observable<IAPIResponse<IAPIPromotionModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      code: code,
    });
    return this.httpService.get<IAPIResponse<IAPIPromotionModel>>(
      url.checkPromoCodeByCode,
      params
    );
  }
}

export default new PromotionService();